import {inject, Pipe, PipeTransform, SecurityContext} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser'

@Pipe({
  name: 'bypassTrustHtml'
})
export class BypassTrustHtmlPipe implements PipeTransform {
  private _sanitized = inject(DomSanitizer);

  constructor(){}

  transform(value:string): SafeHtml {
    return this._sanitized.sanitize(SecurityContext.HTML,value) || '';
  }
}
